import * as angular from "angular";
import {IController, IQService} from "angular";
import * as _ from "lodash";
import {AccountModel} from "../../../account/angular/models/account.model";

export class vehicleSelectCtrl implements IController {

  form: any;
  selectedId: any;
  ngPlaceholder: any;
  formName: any;
  excludeIds: any;
  options: any;
  useDefault: boolean;
  isRequired: boolean;
  onChange: Function;

  private vehiclesRef: any;
  private loaded: boolean;
  private accounts: AccountModel[];
  private selectedAccount: any;
  private searchTerm: string;
  private selectedVehicle: any;
  private vehicles: any;
  private defaultSiteVehicle: any;

  /* @ngInject */
  constructor(private $mdSelect, private $log, private $q: IQService, private $vehicles) {
  }

  $onInit() {
    this.vehiclesRef = this.$vehicles();
    this.loaded = false;
    this.accounts = [];
    this.selectedAccount = undefined;
    this.searchTerm = '';

    this._getVehicles();
  };

  onOpen() {
    return !this.loaded ? this._getVehicles() : this.$q.when();
  }

  onClose() {
    this.searchTerm = '';
    this.onChange({vehicle: this.selectedVehicle});
    this.$mdSelect.hide();
  }

  cancel() {
    this.$mdSelect.hide();
  }

  reset() {
    this.selectedVehicle = undefined;
    this.searchTerm = '';
    this.onChange({vehicle: this.selectedVehicle});
    this.$mdSelect.hide();
  }

  _getVehicles() {
    if (this.options) {
      this.vehicles = _.filter(this.options, (v) => {
        return !_.includes(this.excludeIds, v.id);
      });
      return this.$q.when();
    } else {
      return this.vehiclesRef.$getAll()
        .then((ids) => {
          return this.vehiclesRef.$asyncValues(ids);
        })
        .then((vehicles) => {
          this.vehicles = _.filter(vehicles, (v) => {
            return !_.includes(this.excludeIds, v.id);
          });
          this.selectedVehicle = _.find(vehicles, (v) => {
            return _.isEqual(this.selectedId, v.id);
          });
          this.defaultSiteVehicle = this._getDefaultSiteVehicle();
          if (!this.selectedVehicle && !!this.useDefault) {
            this.selectedVehicle = this.defaultSiteVehicle;
            this.onChange({vehicle: this.selectedVehicle});
          }
          this.loaded = true;
        })
        .catch((error) => {
          this.$log.error('Failed to get vehicles', error)
        });
    }
  }

  _getDefaultSiteVehicle() {
    const defaultVehicles = _.filter(this.vehicles, (v) => {
      return v.isDefault == true;
    });
    return defaultVehicles[0];
  }

}

angular
  .module('bringoz.admin.vehicles')
  .component('vehicleSelect', {
    require: {
      form: '^form'
    },
    bindings: {
      selectedId: '<',
      ngPlaceholder: '@?',
      formName: '@?',
      useDefault: '<?',
      options: '<?',
      excludeIds: '<?',
      isRequired: '<?',
      onChange: '&'
    },
    template: require('./vehicle-select.html').default,
    controller: vehicleSelectCtrl
  });

